import {
  Box,
  CircularProgress,
  ClickAwayListener,
  colors,
  Divider,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { selectActiveSession } from "app/modules/schools/selectors";
import {
  getStudentByName,
  getStudentByNameAndSession,
} from "app/services/schoolService/studentReport.service";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import appRoutes from "app/config/routes";
import { Close } from "@mui/icons-material";
import { formatGuardianString } from "app/utils/helper";
const StudentCard = ({ item }) => {
  return (
    <Box
      my={1}
      sx={{
        color: item?.active
          ? "primary"
          : item?.migrated
          ? colors.blue[500]
          : item?.suspended
          ? colors.yellow[900]
          : item?.promoted
          ? colors.green[700]
          : item?.deleted && colors.red[600],
      }}
    >
      <Stack direction="row" spacing={1} alignItems={"center"} px={2}>
        {/* student profile pic */}
        <div>
          <img
            src={
              item?.profilePic ? item?.profilePic : "/image-placeholder.jpeg"
            }
            alt="student"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        {/* student details */}
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "15px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {item?.name}
          </Typography>

          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            {formatGuardianString(
              item?.gender,
              item?.fatherName || item?.motherName || ""
            )}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Class Info:- {item?.classInfo ?? ""}
          </Typography>
          <Stack direction={"row"} gap={2} alignItems={"center"}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              Reg No:- {item?.registrationNumber}
            </Typography>

            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "12px",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              Adm No:- {item?.admissionNumber}
            </Typography>
          </Stack>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Status:-{" "}
            {item?.deleted ? (
              <span>Deleted</span>
            ) : item?.migrated ? (
              <span>Migrated</span>
            ) : item?.active ? (
              <span>Active</span>
            ) : item?.promoted ? (
              <span>Promoted</span>
            ) : item?.suspended ? (
              <span>Suspended</span>
            ) : (
              ""
            )}
          </Typography>
        </Stack>
      </Stack>
      <Divider sx={{ background: "rgba(0,0,0,0.3)", mt: 1 }} />
    </Box>
  );
};
const StudentSearchDialogDashboard = ({
  value,
  radio,
  handleOnClickStudent,
  isNavigateToProfile = true,
  returnResponse = () => {},
}) => {
  const [state, setState] = useState({
    name: "",
    page: 1,
    studentData: {},
    menuOpen: false,
    selectedStudent: [],
    isFocus: false,
  });
  const listRef = useRef(null);
  const selectedSession = useSelector(selectActiveSession);
  const {
    isFetching: getStudentByNameFetching,
    isLoading: getStudentByNameLoading,
  } = useQuery({
    queryKey: ["getStudentByName", state.name, state.page, radio],

    queryFn: () => {
      const params = {
        ...(radio === "activeSession" && {
          session: selectedSession,
          active: true,
        }),

        studentName: undefined,
        registrationNumber: undefined,
        admissionNumber: undefined,
        srNumber: undefined,
        penNumber_center: undefined,
        AADHAR: undefined,
        mobileNumber: undefined,
        page: state.page,
      };

      switch (value) {
        case "Student Name":
          params.studentName = state.name;
          break;
        case "Sr Number":
          params.srNumber = state.name;
          break;
        case "PEN Number":
          params.penNumber_center = state.name;
          break;
        case "Admission Number":
          params.admissionNumber = state.name;
          break;
        case "Registration Number":
          params.registrationNumber = state.name;
          break;
        case "Father Name":
          params.fatherName = state.name;
          break;
        case "Mother Name":
          params.motherName = state.name;
          break;
        case "Mobile Number":
          params.mobileNumber = state.name;
          break;
        case "AADHAR":
          params.AADHAR = state.name;
          break;
        default:
          break;
      }
      if (radio === "activeSession") {
        return getStudentByNameAndSession(params);
      } else {
        return getStudentByName(params);
      }
    },
    onSuccess: (success) => {
      if (Number(state.page) !== 1) {
        setState((prev) => ({
          ...prev,
          studentData: {
            ...prev.studentData,
            ...success?.data,
            list: [...prev?.studentData?.list, ...success?.data?.list],
          },
        }));
      } else {
        setState((prev) => ({ ...prev, studentData: success?.data }));
      }
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
    enabled: state.name ? true : false,
  });
  const handleLinkClick = (e, studentDocId) => {
    if (handleOnClickStudent) {
      e.preventDefault();
      handleOnClickStudent(studentDocId);
      setState((prev) => ({ ...prev, isFocus: false }));
      return;
    }
  };
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      name: "",
      page: 1,
      studentData: {},
      menuOpen: false,
      selectedStudent: [],
    }));
  }, [value]);
  useEffect(() => {
    if (listRef.current) {
      const scrollDiv = listRef.current;
      setState((prev) => ({
        ...prev,
        scrollPosition: scrollDiv.scrollTop,
      }));
    }
  }, [state.page]);

  useEffect(() => {
    if (listRef.current && Number(state.page) > 1) {
      const scrollDiv = listRef.current;
      scrollDiv.scrollTo({
        top: state.scrollPosition || 0,
      });
    }
  }, [state.studentData, state.page, state.scrollPosition]);

  return (
    <Box>
      <ClickAwayListener
        onClickAway={() => setState((prev) => ({ ...prev, isFocus: false }))}
      >
        <Wrapper>
          <div className="input_box">
            <input
              onFocus={() => setState((prev) => ({ ...prev, isFocus: true }))}
              type={
                value === "Mobile Number" || value === "AADHAR"
                  ? "number"
                  : "text"
              }
              placeholder={`Type ${value}`}
              value={state.name}
              onChange={(e) => {
                if (value === "Mobile Number" && e.target.value.length >= 11) {
                  return;
                }
                if (value === "AADHAR" && e.target.value.length >= 13) {
                  return;
                }

                e.stopPropagation();
                setState((prev) => ({
                  ...prev,
                  name: e.target.value,
                  ...(state.page !== 1 && { page: 1 }),
                  ...(!e.target.value && { studentData: {} }),
                }));
              }}
              className="custom_input"
            />
            {state.name && (
              <div
                onClick={() =>
                  setState((prev) => ({ ...prev, name: "", studentData: {} }))
                }
              >
                <Close className="close_icon" />
              </div>
            )}
          </div>
          {/* box */}
          {state.name && state.isFocus && (
            <div className="student_box__wrapper">
              <div className="student_box" ref={listRef} id="scrollDivStudent">
                {(getStudentByNameFetching || getStudentByNameLoading) && (
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    sx={{ position: "absolute", left: 0, right: 0 }}
                  >
                    <CircularProgress />
                  </Stack>
                )}

                {state.studentData?.list?.map((item, ind) =>
                  isNavigateToProfile ? (
                    <Link
                      onClick={(e) => handleLinkClick(e, item?.studentDocId)}
                      to={`/${appRoutes.student_profile}/${item?.studentDocId}`}
                      style={{ textDecoration: "none" }}
                      className="card_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      key={ind}
                    >
                      <StudentCard item={item} />
                    </Link>
                  ) : (
                    <Box
                      key={ind}
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        setState((prev) => ({
                          ...prev,
                          name: "",
                          isFocus: false,
                        }));
                        returnResponse(item);
                      }}
                    >
                      <StudentCard item={item} />
                    </Box>
                  )
                )}
                {state.studentData?.pages !== state.studentData?.page && (
                  <Stack direction={"row"} justifyContent={"center"}>
                    <Typography
                      sx={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                        textAlign: "center",
                        display: "inline-block",
                        mb: 1,
                      }}
                      onClick={() =>
                        setState((prev) => ({ ...prev, page: prev.page + 1 }))
                      }
                    >
                      more
                    </Typography>
                  </Stack>
                )}
              </div>
            </div>
          )}
        </Wrapper>
      </ClickAwayListener>
    </Box>
  );
};

export default StudentSearchDialogDashboard;
const Wrapper = styled(Box)`
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: visible;
  z-index: 1;

  &:has(.custom_input:focus) {
    z-index: 10000;
  }

  .input_box {
    padding: 12px 16px;
    border: 2px solid rgba(2, 122, 233, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
    border-radius: 12px;
    box-shadow: 0px 2px 8px rgba(2, 122, 233, 0.04);
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: rgba(2, 122, 233, 0.2);
      box-shadow: 0px 4px 16px rgba(2, 122, 233, 0.08);
      transform: translateY(-1px);
    }

    &:focus-within {
      border: 2px solid #027ae9;
      box-shadow: 0px 4px 16px rgba(2, 122, 233, 0.15);
      transform: translateY(-2px);
    }
  }

  .close_icon {
    font-size: 14px;
    color: rgba(2, 122, 233, 0.7);
    background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
    cursor: pointer;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(2, 122, 233, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(145deg, #027ae9 0%, #0b5fbb 100%);
      color: white;
      transform: scale(1.1);
    }
  }

  .custom_input {
    width: 100%;
    outline: none;
    border: none;
    font-size: 15px;
    font-weight: 500;
    height: 24px;
    background: transparent;
    color: #027ae9;
    letter-spacing: 0.01em;

    &::placeholder {
      color: rgba(2, 122, 233, 0.5);
      font-weight: 400;
    }
  }

  .student_box__wrapper {
    position: absolute;
    width: min(420px, 90vw);
    max-width: 420px;
    max-height: 380px;
    padding-top: 8px;
    z-index: 9999;
    left: 0;
    top: 100%;
    right: auto;

    @media (max-width: 600px) {
      width: min(350px, 90vw);
      left: -10px;
    }

    .student_box {
      padding: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(145deg, #ffffff 0%, #f0f8ff 100%);
      border-radius: 16px;
      border: 1px solid rgba(2, 122, 233, 0.12);
      box-shadow: 0px 8px 32px rgba(2, 122, 233, 0.15),
        0px 4px 16px rgba(0, 0, 0, 0.08);
      backdrop-filter: blur(20px);
      overflow-y: auto;
      max-height: 380px;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: rgba(2, 122, 233, 0.05);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: linear-gradient(145deg, #027ae9 0%, #0b5fbb 100%);
        border-radius: 10px;

        &:hover {
          background: linear-gradient(145deg, #0b5fbb 0%, #027ae9 100%);
        }
      }
    }
  }

  .student_item {
    padding: 16px;
    margin: 8px 12px;
    border-radius: 12px;
    border: 1px solid rgba(2, 122, 233, 0.08);
    background: linear-gradient(145deg, #ffffff 0%, #fafbff 100%);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:hover {
      transform: translateY(-2px);
      border-color: rgba(2, 122, 233, 0.2);
      box-shadow: 0px 6px 20px rgba(2, 122, 233, 0.12);
      background: linear-gradient(145deg, #f0f8ff 0%, #ffffff 100%);
    }

    &:first-child {
      margin-top: 12px;
    }

    &:last-child {
      margin-bottom: 12px;
    }
  }

  .student_avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid rgba(2, 122, 233, 0.1);
    box-shadow: 0px 2px 8px rgba(2, 122, 233, 0.1);
    transition: all 0.3s ease;

    .student_item:hover & {
      border-color: rgba(2, 122, 233, 0.3);
      transform: scale(1.05);
      box-shadow: 0px 4px 12px rgba(2, 122, 233, 0.2);
    }
  }

  .student_name {
    font-weight: 600;
    font-size: 15px;
    color: #027ae9;
    margin-bottom: 4px;
    letter-spacing: 0.01em;
  }

  .student_detail {
    font-weight: 400;
    font-size: 12px;
    color: rgba(12, 47, 73, 0.7);
    line-height: 1.4;
    margin-bottom: 2px;
  }

  .more_button {
    color: #027ae9;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    display: inline-block;
    margin: 12px 0 16px 0;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(
      145deg,
      rgba(2, 122, 233, 0.1) 0%,
      rgba(11, 95, 187, 0.1) 100%
    );
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(145deg, #027ae9 0%, #0b5fbb 100%);
      color: white;
      transform: translateY(-1px);
      box-shadow: 0px 4px 12px rgba(2, 122, 233, 0.3);
    }
  }

  .loading_container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
  }
`;
